export default class RepairDiagnosticsSessionResponse {
  public repairDiagnosticsSessionIdentifier: string = "";

  constructor(response?: any) {
    if (response && response.repairDiagnosticsSessionIdentifier) {
      this.repairDiagnosticsSessionIdentifier = response.repairDiagnosticsSessionIdentifier;
    }
  }
}
